<div
  class="st-side-menu"
  stCollapsible
  [isCollapsed]="menuExpanded$ | async"
  [direction]="'horizontal'"
  [maxWidth]="menuMaxWidth()"
  [minWidth]="0"
>
  @if (navigationItem$ | async; as nav) {
    <div class="st-side-menu-logo">
      <img [src]="logoUrl()" alt="" />
    </div>
    @if (menuExpanded$ | async) {
      <div class="st-side-menu-container">
        <div class="st-side-menu-container-inner w-full">
          @if (nav.children.length) {
            <div class="menu-header">
              <div class="body-large-bold webkit-box-one-line">
                {{ nav.name }}
              </div>
            </div>
            @for (item of nav.children; track $index) {
              <st-menu-collapse-item
                [menuItemData]="item"
                [active]="activeChild && activeChild.id === item.id"
              ></st-menu-collapse-item>
            }
          }
        </div>
      </div>
    }
  }
</div>
